import React from "react";
import { TFunction } from "i18next";
import { StyledLabel, StyledTextInput } from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";

type Props = {
    remark: string;
    setRemark: (v: string) => void;
    setIsEdited: (v: boolean) => void;
    isConsult: boolean;
    t: TFunction;
};

export default function RemarkField({ remark, setRemark, setIsEdited, isConsult, t }: Props) {
    return (
        <AvGroup className={isConsult ? "pe-none__clz" : ""}>
            <StyledLabel className="mt-3" htmlFor="remark">
                {t("Remark")}
            </StyledLabel>
            <StyledTextInput
                data-testid="fidelity-franchise-remark-input"
                autocomplete="off"
                id="remark"
                name="remark"
                placeholder={t("Write")}
                type="text"
                onChange={(e: any) => {
                    setRemark(e.target.value);
                    setIsEdited(true);
                }}
                value={remark}
            />
        </AvGroup>
    );
}
